"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyRoleSummary = exports.StudyRoleUpload = exports.StudyRoleUploadResultCode = exports.StudyRoleUploadStatus = exports.StudyRole = void 0;
class StudyRole {
}
exports.StudyRole = StudyRole;
var StudyRoleUploadStatus;
(function (StudyRoleUploadStatus) {
    StudyRoleUploadStatus["Wait"] = "WAIT";
    StudyRoleUploadStatus["Processing"] = "PROCESSING";
    StudyRoleUploadStatus["Processed"] = "PROCESSED";
    StudyRoleUploadStatus["Failed"] = "FAILED";
})(StudyRoleUploadStatus = exports.StudyRoleUploadStatus || (exports.StudyRoleUploadStatus = {}));
var StudyRoleUploadResultCode;
(function (StudyRoleUploadResultCode) {
    StudyRoleUploadResultCode["Done"] = "DONE";
    StudyRoleUploadResultCode["UnexpectedError"] = "UNEXPECTED_ERROR";
    StudyRoleUploadResultCode["FileNotExist"] = "FILE_NOT_EXIST";
    StudyRoleUploadResultCode["MissingRole"] = "MISSING_ROLE";
    StudyRoleUploadResultCode["DuplicatedName"] = "DUPLICATED_NAME";
    StudyRoleUploadResultCode["InvalidRoleInactive"] = "INVALID_ROLE_INACTIVE";
    StudyRoleUploadResultCode["InvalidPrivCount"] = "INVALID_PRIV_COUNT";
    StudyRoleUploadResultCode["InvalidPrivItem"] = "INVALID_PRIV_ITEM";
    StudyRoleUploadResultCode["InvalidPrivSymbol"] = "INVALID_PRIV_SYMBOL";
})(StudyRoleUploadResultCode = exports.StudyRoleUploadResultCode || (exports.StudyRoleUploadResultCode = {}));
class StudyRoleUpload {
}
exports.StudyRoleUpload = StudyRoleUpload;
class StudyRoleSummary {
}
exports.StudyRoleSummary = StudyRoleSummary;
//# sourceMappingURL=studyRole.js.map